import { CachingProxyStyle } from './caching-proxy-style';

export class ArrowCachingProxyStyle extends CachingProxyStyle {

  constructor (style, fadingSupplier, imageCache, rotation, distanceBetweenPointsSquared, visibilityProvider, cachedZoomFactor) {
    super(style, fadingSupplier);
    this._imageCache = imageCache;
    this._rotation = rotation;
    this._distanceBetweenPointsSquared = distanceBetweenPointsSquared;
    this._visibilityProvider = visibilityProvider;
    this._cachedZoomFactor = cachedZoomFactor;
  }

  getImage () {
    const baseImage = super.getImage();
    if (baseImage) {
      return this.getUpdated(this._imageCache, baseImage);
    }
    return baseImage;
  }

  getKey (fadingFactor, fadingTransition) {
    // concat with + for performance reasons
    return fadingFactor + '_'
      + fadingTransition + '_'
      + this._cachedZoomFactor.zoom + '_'
      + this._distanceBetweenPointsSquared + '_'
      + this._rotation + '_';
  }

  createImage (fadingFactor, fadingTransition, baseImage) {
    if (fadingFactor === 0 || !this._visibilityProvider()) {
      return null; // Should not be displayed
    }

    if (fadingFactor === 1) {
      return baseImage; // Show original
    }

    const opacity = this._getNewOpacity(baseImage, fadingFactor, fadingTransition);

    // Possible performance extension point:
    // Add second level cache by fetching image from cache with reduced key consisting of only
    // opacity, rotation and the _real screen coordinates_. The latter is not used as a key
    // in the first level cache key as the calculation is too expensive. This would reduces the
    // amount of styles generated and stored vastly.

    const newImage = baseImage.clone();
    newImage.setOpacity(opacity);
    return newImage;
  }

  _getNewOpacity (image, fadingFactor, fadingTransition) {
    return this.getOpacityForFadingFactor(image.getOpacity(), fadingFactor, fadingTransition);
  }

}
